import K from '../constants';
import restHelpers from '../helpers/restHelper';
import getCarMockresponse from './__mocks/carView/getCarWithRpm';

const getAlarmsFn = leadId => restHelpers.withBearer.get(`${K.API_URL}/alarms/leads/${leadId}`, {});

const getCarFn = carId => restHelpers.withBearer.get(`${K.API_URL}/cars/${carId}`, {});

const getCarMockFnIgnored = () => Promise.resolve(getCarMockresponse);

const getDtcsFn = leadId => restHelpers.withBearer.get(`${K.API_URL}/dtcs/leads/${leadId}`, {});

const getLeadFn = carId => restHelpers.withBearer.get(`${K.API_URL}/leads/cars/${carId}`, {});

const getMaintenancesFn = leadId => restHelpers.withBearer.get(`${K.API_URL}/maintenances/leads/${leadId}`, {});

const sendNoteFn = (carId, note) => restHelpers.withBearer.post(`${K.API_URL}/notes`, { data: { note, carId } });

const getDtcsHistoryFn = (carId, page = 1, size = 10, sort = '', order = '') =>
  restHelpers.withBearer.get(
    `${K.API_URL}/dtc-histories/cars/${carId}?_=${new Date().getTime()}&page=${page - 1}&size=${size}${sort !== '' && order !== '' ? `&sort=${sort}&order=${order}` : '&sort=recordedAt&order=DESC'}`,
    {}
  );

const getAlarmsHistoryFn = (carId, page = 1, size = 10, sort = '', order = '') =>
  restHelpers.withBearer.get(
    `${K.API_URL}/alarm-histories/cars/${carId}?_=${new Date().getTime()}&page=${page - 1}&size=${size}${sort !== '' && order !== '' ? `&sort=${sort}&order=${order}` : '&sort=recordedAt&order=DESC'}`,
    {}
  );

const getMaintenancesHistoryFn = (carId, page = 1, size = 10, sort = '', order = '') =>
  restHelpers.withBearer.get(
    `${K.API_URL}/maintenance-histories/cars/${carId}?_=${new Date().getTime()}&page=${page - 1}&size=${size}${sort !== '' && order !== '' ? `&sort=${sort}&order=${order}` : ''}`,
    {}
  );

const getCrashEventsCountFn = (plate, startTime, endTime) => restHelpers.withBearer.get(`${K.API_URL}/crash-reports/count-events/${plate}/${startTime}/${endTime}`, {});

const getFuelVariationsFn = (carId, startDate, endDate, type, page, size, sort = 'createdAt', order = 'DESC') =>
  restHelpers.withBearer.get(
    `${K.API_URL}/fuel-variations/cars/${carId}/${startDate}/${endDate}?_=${new Date().getTime()}${type !== undefined ? `&type=${type}` : ''}${
      page !== undefined && size !== undefined ? `&page=${parseInt(page, 10) - 1}&size=${size}` : ''
    }${sort !== '' && order !== '' ? `&sort=${sort}&order=${order}` : ''}`,
    {}
  );

const getFuelLevelsFn = (carId, startDate, endDate) =>
  restHelpers.withBearer.get(`${K.API_URL}/fuel-level-histories/cars/${carId}/${startDate}/${endDate}?_=${new Date().getTime()}`, {});

const doorActionFn = (vin, action) => restHelpers.withBearer.post(`${K.API_URL}/cars/${vin}/manage-door`, { data: { action } });

const engineActionFn = (vin, action) => restHelpers.withBearer.post(`${K.API_URL}/cars/${vin}/manage-engine`, { data: { action } });

const doorControlHistoryFn = (carId, page = 1, size = 10, sort = '', order = '') =>
  restHelpers.withBearer.get(
    `${K.API_URL}/door-control-histories/cars/${carId}?_=${new Date().getTime()}&page=${page - 1}&size=${size}${
      sort !== '' && order !== '' ? `&sort=${sort}&order=${order}` : ''
    }`,
    {}
  );

const engineControlHistoryFn = (carId, page = 1, size = 10, sort = '', order = '') =>
  restHelpers.withBearer.get(
    `${K.API_URL}/engine-control-histories/cars/${carId}?_=${new Date().getTime()}&page=${page - 1}&size=${size}${
      sort !== '' && order !== '' ? `&sort=${sort}&order=${order}` : ''
    }`,
    {}
  );

export default {
  getAlarms: getAlarmsFn,
  getCar: getCarFn,
  _getCar: getCarMockFnIgnored,
  getDtcs: getDtcsFn,
  getLead: getLeadFn,
  getMaintenances: getMaintenancesFn,
  sendNote: sendNoteFn,
  getDtcsHistory: getDtcsHistoryFn,
  getAlarmsHistory: getAlarmsHistoryFn,
  getMaintenancesHistory: getMaintenancesHistoryFn,
  getCrashEventsCount: getCrashEventsCountFn,
  getFuelVariations: getFuelVariationsFn,
  getFuelLevels: getFuelLevelsFn,
  doorAction: doorActionFn,
  engineAction: engineActionFn,
  getDoorControlHistory: doorControlHistoryFn,
  getEngineControlHistory: engineControlHistoryFn
};



// WEBPACK FOOTER //
// ./src/services/carView.js